import InitialState from './InitialState';
import IReducerReturn from '../../../store/IReducerReturn';
import * as ActionTypes from './ActionTypes';
import * as BasicInfoActionTypes from './basicorderinfo/ActionTypes';
import { assign } from '../../../shared/Assign';
import * as OrderActionTypes from './ActionTypes';

export default function viewOrderReducer(
    state: any = InitialState.viewOrder,
    action: IReducerReturn
) {
    switch (action.type) {
        case ActionTypes.GET_COMMON_ORDER_SUCCESS: {
            const newState = assign({}, state);
            newState.common = assign({}, action.result);
            return newState;
        }

        case ActionTypes.ASSIGN_USER_ORDER_SUCCESS: {
            const newState = assign({}, state);
            newState.common.assignedUserId = action.result.assignedUserId;
            newState.common.assignedUserName = action.result.assignedUserName;
            return newState;
        }

        case BasicInfoActionTypes.CREATE_ORDER_ROW_SUCCESS:
        case BasicInfoActionTypes.UPDATE_ORDER_ROW_SUCCESS: {
            const newState = assign({}, state);
            newState.common.productProperties = action.result.orderProductProperties;
            return newState;
        }

        case OrderActionTypes.RESET_ORDER_STATES:
            return InitialState.viewOrder;

        case OrderActionTypes.REFRESH_STITCH_IMAGES_STATUS: {
            const newState = assign({}, state);
            newState.common.allowStitchingOfEditingImages = assign({}, action.result);
            return newState;
        }

        default:
            return state;
    }
}

let selectViewOrder = (state: any) => state.viewOrder;
export let selectViewOrderCommon = (state: any) => selectViewOrder(state).common;
export let selectViewOrderProductProperties = (state: any) => selectViewOrderCommon(state).productProperties;
export let selectViewOrderDigitalStylingOrderStatus = (state: any) => selectViewOrderCommon(state).digitalStylingOrderStatus;
